import { Upload } from "lucide-react";
import { useEntityFileContext } from "../context/EntityFileContext";
import { forwardRef, useRef } from "react";
import { Button } from "@/modern/components/ui/button-shadcn";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";

export const UploadFileMenuButton = forwardRef<HTMLButtonElement, { record?: unknown; onFinish?: () => void }>(({ record, onFinish }, ref) => {
  const { uploadNewFile } = useEntityFileContext();
  const uploadFileRef = useRef<HTMLInputElement>(null);
  if (!record) {
    return (
      <div className="flex items-center gap-2 rounded-sm px-2 py-1.5 text-sm text-muted-foreground">
        <Upload className="size-4 mr-1" />
        <span>No task selected</span>
      </div>
    );
  }

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      await uploadNewFile(e.target.files);
      e.target.value = "";
      onFinish?.();
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          ref={ref}
          variant="entityHeader"
          // className="w-full hover:bg-accent hover:text-accent-foreground relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4"
          onClick={() => uploadFileRef.current?.click()}
        >
          <Upload />
          <label className=" items-center gap-3 hidden">
            <input ref={uploadFileRef} type="file" className="hidden" multiple onChange={handleFileChange} id="file-upload" />
            <Upload className="!h-3.5 !w-3.5" />
            <span>Add files</span>
          </label>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Upload file</p>
      </TooltipContent>
    </Tooltip>
  );
});
UploadFileMenuButton.displayName = "UploadFileMenuButton";
